"use client";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { companyMilestones as data } from "@/lib/data/press";

const accent = "var(--color-crimson)";

export function CompanyMilestones() {
  return (
    <Section id="company-milestones" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-crimson)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 relative">
          <div className="hidden lg:block absolute top-0 bottom-0 left-[27px] w-px" style={{ background: `linear-gradient(180deg, transparent, color-mix(in oklch, ${accent} 50%, transparent) 10%, color-mix(in oklch, var(--color-cyan) 50%, transparent) 50%, color-mix(in oklch, var(--color-amber) 50%, transparent) 90%, transparent)` }} aria-hidden />
          <div className="space-y-6">
            {data.timeline.map((t, i) => {
              const c = ["var(--color-crimson)", "var(--color-cyan)", "var(--color-amber)", "var(--color-emerald)", "var(--color-purple)"][i % 5]!;
              return (
                <Reveal key={t.year + t.milestone} delay={i * 50}>
                  <div className="relative flex gap-6 items-start">
                    <div className="shrink-0 relative">
                      <div className="grid place-items-center h-14 w-14 rounded-2xl glass relative z-10" style={{ boxShadow: `0 0 0 4px rgb(var(--bg)), inset 0 0 0 1px color-mix(in oklch, ${c} 35%, transparent)` }}>
                        <span className="text-xs font-bold tracking-wider" style={{ color: c }}>{t.year}</span>
                      </div>
                    </div>
                    <div className="flex-1 pt-2">
                      <p className="text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{t.milestone}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
